/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Close_DialogInputs */

const en_close_dialog = /** @type {(inputs: Close_DialogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close dialog`)
};

const fr_close_dialog = /** @type {(inputs: Close_DialogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer la boîte de dialogue`)
};

const de_close_dialog = /** @type {(inputs: Close_DialogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dialog schließen`)
};

const it_close_dialog = /** @type {(inputs: Close_DialogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi finestra di dialogo`)
};

const ru_close_dialog = /** @type {(inputs: Close_DialogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрыть диалог`)
};

const es_close_dialog = /** @type {(inputs: Close_DialogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar diálogo`)
};

const zh_cn2_close_dialog = /** @type {(inputs: Close_DialogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭对话框`)
};

const ja_close_dialog = /** @type {(inputs: Close_DialogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ダイアログを閉じる`)
};

const hi_close_dialog = /** @type {(inputs: Close_DialogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संवाद बंद करें`)
};

const pt_pt2_close_dialog = /** @type {(inputs: Close_DialogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar caixa de diálogo`)
};

/**
* | output |
* | --- |
* | "Close dialog" |
*
* @param {Close_DialogInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const close_dialog = /** @type {((inputs?: Close_DialogInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Close_DialogInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_close_dialog(inputs)
	if (locale === "de") return de_close_dialog(inputs)
	if (locale === "it") return it_close_dialog(inputs)
	if (locale === "ru") return ru_close_dialog(inputs)
	if (locale === "es") return es_close_dialog(inputs)
	if (locale === "zh-CN") return zh_cn2_close_dialog(inputs)
	if (locale === "ja") return ja_close_dialog(inputs)
	if (locale === "hi") return hi_close_dialog(inputs)
	if (locale === "pt-PT") return pt_pt2_close_dialog(inputs)
	return en_close_dialog(inputs)
});